<div class="dialog__port-rule dialog__port-rule--flex">
  <div>
    <div class="dialog__port-number">{{ index() + 1 }}</div>
    <div>
      <div class="dialog__port-text">{{ customerDescription() }}</div>
      <div class="dialog__port-subtext">
        {{ locationDescription() }},
        @if (isUntaggedPort()) {
          <span>{{ "Subscription.UntaggedPort" | translate }}</span>
        } @else {
          <span>{{ "ServiceElement.VLAN" | translate }} {{ vlanrange() }}</span>
        }
      </div>
    </div>
  </div>
  <div>
    <div class="select-wrapper">
      <select name="priority" [(ngModel)]="sap().bgpSessionPriority">
        <option value="primary">primary</option>
        <option value="secondary">secondary</option>
        <option value="tertiary">tertiary</option>
        <option value="quaternary">quaternary</option>
      </select>
      <svg-icon src="assets/images/icons/select-arrows.svg"></svg-icon>
    </div>
  </div>
</div>
